
import { mapGetters } from 'vuex'
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'
import EralpPagination from 'gurhan/vue/BootstrapPagination.vue'

const LIMIT = 50

export default {
  name: 'ExamList',
  components: {
    InnerLoading,
    EralpPagination,
  },
  props: {
    isRedirectable: {
      type: Boolean,
      default: false,
    },
    eventItemId: {
      type: [String, Number],
      default: '',
    },
    productId: {
      type: [String, Number],
      default: '',
    },
    videoId: {
      type: [String, Number],
      default: '',
    },
    examId: {
      type: [String, Number],
      default: '',
    },
    limit: {
      type: Number,
      default: LIMIT,
    },
  },
  data() {
    return {
      examList: [],
      isLoading: true,
      page: 1,
      count: 0,
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
      getExamServiceUrl: 'getExamServiceUrl',
    }),
    isLoggedIn() {
      return this.getActiveUser.token
    },
    isExamServiceLoggedIn() {
      return this.getActiveUser.examServiceToken
    },
    pages() {
      return Math.ceil(this.count / this.limit) || 0
    },
  },
  methods: {
    buildQuery() {
      const params = new URLSearchParams()
      if (this.productId !== '' && this.productId != null) {
        params.set('productId', this.productId)
      }
      if (this.eventItemId !== '' && this.eventItemId != null) {
        params.set('eventItemId', this.eventItemId)
      }
      if (this.videoId !== '' && this.videoId != null) {
        params.set('videoId', this.videoId)
      }
      if (this.examId !== '' && this.examId != null) {
        params.set('examId', this.examId)
      }
      params.set('page', this.page)
      params.set('limit', this.limit)
      return params.toString()
    },
    async getExamList() {
      if (!this.isExamServiceLoggedIn) {
        this.examList = []
        this.count = 0
        this.isLoading = false
        return
      }
      this.isLoading = true
      const response = await this.$api.get(`ExamProduct?${this.buildQuery()}`)
      if (response.message === 'OK') {
        this.examList = response.data.items || []
        this.count = response.data.count || this.examList.length || 0
      } else {
        this.examList = []
        this.count = 0
      }
      this.isLoading = false
    },
    async SET_PAGINATION(page) {
      this.page = page
      await this.getExamList()
    },
  },
  mounted() {
    this.getExamList()
  },
}
